import globalMU from 'globalMU';
import React from 'react';

export type AmbienteItemProps = {
    cor: string
    nome: string
    onSelecionado: () => void
}

export const AmbienteItem = (props: AmbienteItemProps) => {
    return <div style={{
        backgroundColor: globalMU.isNotNullOrEmpty(props.cor) ? props.cor : "#c4c4c4",
        maxWidth: '100px',
        textAlign: 'center',
        color: "white"
    }}
    className="_cursor-default"
        onClick={() => props.onSelecionado()}>
        {globalMU.isNotNullOrEmpty(props.nome) ? props.nome : "Definir"}
    </div>
}